import { render, staticRenderFns } from "./smsList.vue?vue&type=template&id=6ebb767d&scoped=true&"
import script from "./smsList.vue?vue&type=script&lang=js&"
export * from "./smsList.vue?vue&type=script&lang=js&"
import style0 from "./smsList.vue?vue&type=style&index=0&id=6ebb767d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb767d",
  null
  
)

export default component.exports